import { createAuthClient } from 'better-auth/react'

// Dynamically determine baseURL - use env var in dev, current origin in production
const getBaseURL = () => {
  // Server-side: use env var
  if (typeof window === 'undefined') {
    return process.env.NEXT_PUBLIC_SERVER_URL || ''
  }
  // Client-side: use current origin for production, env var for dev
  if (process.env.NODE_ENV === 'development') {
    return process.env.NEXT_PUBLIC_SERVER_URL || ''
  }
  return window.location.origin
}

export const authClient = createAuthClient({
  baseURL: getBaseURL(),
})

export const {
  signIn,
  signUp,
  signOut,
  useSession,
  getSession,
  changePassword,
  updateUser,
  deleteUser,
} = authClient

// Password reset functions using direct API calls
export async function forgetPassword(data: { email: string; redirectTo?: string }) {
  const baseURL = getBaseURL()
  const response = await fetch(`${baseURL}/api/auth/request-password-reset`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
    credentials: 'include',
  })
  return response.json()
}

export async function resetPassword(data: { newPassword: string; token: string }) {
  const baseURL = getBaseURL()
  const response = await fetch(`${baseURL}/api/auth/reset-password`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
    credentials: 'include',
  })
  const result = await response.json()
  if (!response.ok) {
    return { error: result.error || { code: 'UNKNOWN_ERROR', message: 'Password reset failed' } }
  }
  return result
}
